export const INFO = 'info'
export const SUCCESS = 'success'
export const WARN = 'warn'
export const FAIL = 'fail'
